<template>
  <div>
  <v-list color="transparent">
    <v-list-item class="px-0">
      <v-list-item-icon class="mr-3">
        <v-icon color="error"
                class="material-icons-outlined">
          error_outline
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <div class="font-size-04 mb-2 error--text font-weight-bold">
          {{ $t('add-device-dialog.step-error.title') }}
        </div>
        <div class="font-size-03">
          {{ $t('add-device-dialog.step-error.description') }}
        </div>

      </v-list-item-content>
    </v-list-item>
  </v-list>
  <v-card>
    <v-card-text>

      <v-list color="transparent">
        <v-list-item class="px-0">
          <v-list-item-content>
            <div class="font-size-03">
              {{ $t('add-device-dialog.step-error.hints') }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="px-0">
          <v-list-item-icon class="mr-3">
            <v-icon color="primary"
                    class="material-icons-outlined">
              check_circle
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="font-size-03">
              {{ $t('add-device-dialog.step-error.hint1') }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="px-0">
          <v-list-item-icon class="mr-3">
            <v-icon color="primary"
                    class="material-icons-outlined">
              check_circle
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="font-size-03">
              {{ $t('add-device-dialog.step-error.hint2') }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="px-0">
          <v-list-item-icon class="mr-3">
            <v-icon color="primary"
                    class="material-icons-outlined">
              check_circle
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="font-size-03">
              {{ $t('add-device-dialog.step-error.hint3') }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="px-0">
          <v-list-item-icon class="mr-3">
            <v-icon color="primary"
                    class="material-icons-outlined">
              check_circle
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="font-size-03">
              {{ $t('add-device-dialog.step-error.hint4') }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="px-0">
          <v-list-item-icon class="mr-3">
            <v-icon color="primary"
                    class="material-icons-outlined">
              check_circle
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="font-size-03">
              {{ $t('add-device-dialog.step-error.hint5') }}
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
  </div>
</template>

<script>
export default {
  name: "AddDeviceStepError"
}
</script>
